import { useState } from 'react';
import { ArrowLeft, CopyPlus, Eye, RotateCcw } from 'lucide-react';
import { useToleranceStore } from '../../stores/toleranceStore';
import { useVersionStore } from '../../stores/versionStore';
import { bannerText } from '../../utils/versionText';
import ConfirmDialog from '../ConfirmDialog';
import { toast } from '../../lib/toast';

// Banner über dem Rechner, solange ein alter Stand angezeigt wird.
export default function VersionPreviewBanner() {
  const preview = useToleranceStore((s) => s.preview);
  const busy = useVersionStore((s) => s.busy);
  const [confirmOpen, setConfirmOpen] = useState(false);
  if (!preview) return null;

  const run = async (fn, okText) => {
    try {
      await fn();
      if (okText) toast.success(okText);
    } catch (err) {
      toast.error(err.message || 'Aktion fehlgeschlagen.');
    }
  };
  const cls = 'inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold rounded-md disabled:opacity-50';

  return (
    <div role="status" className="bg-brand-soft border-b border-[color:var(--color-brand)]/30 px-4 py-2 flex flex-wrap items-center gap-3">
      <Eye size={15} className="text-brand shrink-0" aria-hidden="true" />
      <span className="text-xs font-semibold text-ink flex-1 min-w-[16rem]">{bannerText(preview)}</span>
      <button type="button" disabled={busy} onClick={() => setConfirmOpen(true)} className={`${cls} bg-brand text-white`}>
        <RotateCcw size={13} aria-hidden="true" />Wiederherstellen
      </button>
      <button type="button" disabled={busy} onClick={() => run(() => useVersionStore.getState().copyPreview(), 'Als neue Berechnung angelegt.')} className={`${cls} bg-surface text-ink-2 border border-line`}>
        <CopyPlus size={13} aria-hidden="true" />Als neue Berechnung
      </button>
      <button type="button" disabled={busy} onClick={() => run(() => useVersionStore.getState().endPreview())} className={`${cls} text-ink-2 hover:bg-surface`}>
        <ArrowLeft size={13} aria-hidden="true" />Zurück zum aktuellen Stand
      </button>
      <ConfirmDialog
        open={confirmOpen}
        title="Stand wiederherstellen?"
        message="Aktuellen Stand durch diesen ersetzen? Der aktuelle Stand wird vorher als Version gesichert."
        confirmLabel="Ersetzen"
        onConfirm={async () => { setConfirmOpen(false); await run(() => useVersionStore.getState().restorePreview(), 'Stand wiederhergestellt.'); }}
        onCancel={() => setConfirmOpen(false)}
        variant="amber"
      />
    </div>
  );
}
